/* ═══════════════════════════════════════════════════
   MODE PRÉCOMMANDE — compte à rebours dégressif
   Alimenté par les horodatages UNIX rendus par Liquid
   (data-pc-fin / data-pc-debut), donc calés sur le
   fuseau de la boutique, pas sur celui du visiteur.
   ═══════════════════════════════════════════════════ */
(function () {
  var compteurs = document.querySelectorAll('[data-pc-compteur]');
  if (!compteurs.length) return;

  var deux = function (n) { return n < 10 ? '0' + n : String(n); };
  var bascule = false;

  function pluriel(n, mot) { return n + ' ' + mot + (n > 1 ? 's' : ''); }

  function libelleRestant(j, h, m) {
    if (j > 0) return pluriel(j, 'jour') + ' ' + deux(h) + ' h restants';
    if (h > 0) return deux(h) + ' h ' + deux(m) + ' restantes';
    return 'Dernières minutes';
  }

  function rendre(el, restantMs) {
    var fin = parseInt(el.dataset.pcFin, 10) * 1000;
    var debut = parseInt(el.dataset.pcDebut, 10) * 1000;
    var total = Math.max(1, fin - debut);

    var s = Math.max(0, Math.floor(restantMs / 1000));
    var j = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;

    var vals = { j: j, h: deux(h), m: deux(m), s: deux(sec) };
    Object.keys(vals).forEach(function (cle) {
      el.querySelectorAll('[data-pc="' + cle + '"]').forEach(function (n) {
        var v = String(vals[cle]);
        if (n.textContent !== v) n.textContent = v;
      });
    });

    // Battement discret de la seconde
    var blocSec = el.querySelector('.pc-bloc--sec');
    if (blocSec) {
      blocSec.classList.remove('pc-tick');
      void blocSec.offsetWidth;
      blocSec.classList.add('pc-tick');
    }

    // Jauge dégressive : pleine au début de la période affichée, vide à l'ouverture
    var barre = el.querySelector('[data-pc-barre]');
    if (barre) {
      var part = Math.max(0, Math.min(1, restantMs / total));
      barre.style.width = (part * 100).toFixed(2) + '%';
      var jauge = el.querySelector('.pc-jauge');
      if (jauge) {
        jauge.setAttribute('aria-valuenow', Math.round(part * 100));
        jauge.setAttribute('aria-valuemin', '0');
        jauge.setAttribute('aria-valuemax', '100');
      }
    }

    var restant = el.querySelector('[data-pc-restant]');
    if (restant) restant.textContent = libelleRestant(j, h, m);
  }

  function tick() {
    var maintenant = Date.now();
    var termine = true;

    compteurs.forEach(function (el) {
      var fin = parseInt(el.dataset.pcFin, 10) * 1000;
      if (!fin) return;
      var restant = fin - maintenant;
      if (restant > 0) termine = false;
      rendre(el, restant);
    });

    // Ouverture atteinte : on recharge une fois. Côté Liquid, le compte à rebours
    // disparaît et le bouton d'achat se débloque.
    if (termine && !bascule) {
      bascule = true;
      setTimeout(function () { window.location.reload(); }, 900);
    }
  }

  tick();
  setInterval(tick, 1000);
})();
